export const SUGGESTED_AMOUNTS = {
  OneTime: [3000, 6000, 10000, 20000],
  Weekly: [500, 1000, 2000, 5000],
  BiWeekly: [1000, 2000, 5000, 10000],
  Monthly: [1000, 2500, 5000, 10000],
  Quarterly: [3000, 7500, 15000, 30000],
  Yearly: [10000, 25000, 50000, 100000],
};
